module.exports = __webpack_public_path__ + "static/media/1_12.0e87c869.png";